// extracted by css-extract-rspack-plugin
export default {"contextKindKeyBadge":"X6vy0aCU9ADoV20d"};